import api from '../api';
import apiUpload from '../apiUpload';

class BrandsApi {

    constructor() {
        this.endpoint = 'brands';
    }

    register = data => {
    
        return api.post(`${this.endpoint}/register`, data);
    }

    checkAlias = (alias) => {

        return api.request({
            method: 'GET',
            url: `${this.endpoint}/count?by=default-search&alias=${alias}`,
            data: {},
            headers: {
            'Content-Type' : 'application/json',
            'Accept': 'application/json;charset=UTF-8'
        }
        });
    }

    checkRegistrationNumber = (registrationNumber) => {

        return api.request({
            method: 'GET',
            url: `${this.endpoint}/count?by=default-search&registrationNumber=${registrationNumber}`,
            data: {},
            headers: {
            'Content-Type' : 'application/json',
            'Accept': 'application/json;charset=UTF-8'
        }
        });
    }

    uploadLogo = (formData,brandId) => {
       
        return apiUpload.request({
            method: 'POST',
            url: `${this.endpoint}?id=${brandId}`,
            data: formData,
            headers: {
            'enctype': 'multipart/form-data',
            'Accept': 'application/json;charset=UTF-8'
        }
        });
    }
    

}

const instance = new BrandsApi();

export default instance;